import type { ReactNode } from "react";
import { Link } from "react-router";
import styles from "./StubPage.module.css";

/**
 * Временный экран: маршрут уже есть, продуктовый экран появится в своём срезе.
 * `backLabel={null}` — без ссылки назад, для экранов внутри оболочки с TabBar.
 */
export function StubPage({
  title,
  backLabel = "Назад",
  children,
}: {
  title: string;
  backLabel?: string | null;
  children?: ReactNode;
}) {
  return (
    <main className={styles.page}>
      <h1 className={styles.title}>{title}</h1>
      {children}
      {backLabel && <Link to="/">{backLabel}</Link>}
    </main>
  );
}
